<div class="influencer-module-container module-placeholder-host"
    [style.height]="height" [class.print-mode]="printMode">
    
    <div class="module-header" [class.absolute-header]="useAbsolutePositionHeader">
        <div class="header-row">
            <div class="header">{{title}}</div>
            <achoo-icon-tooltip *ngIf="tooltip" [tooltipMsg]="tooltip"></achoo-icon-tooltip> 
        </div>
        
    </div>
    
    <div class="module-content">
        <ng-content></ng-content>
    </div>

    <influencer-module-placeholder *ngIf="isFetchingData || hasNoData" class="module-placeholder-container" 
        [width]="placeholderWidth" [isFetchingData]="isFetchingData" [hasNoData]="hasNoData">
	</influencer-module-placeholder>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-module-container/influencer-module-container.component.html